import { render, staticRenderFns } from "./add_menu_dialog.vue?vue&type=template&id=fbdd3216&scoped=true"
import script from "./add_menu_dialog.vue?vue&type=script&lang=js"
export * from "./add_menu_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_menu_dialog.vue?vue&type=style&index=0&id=fbdd3216&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdd3216",
  null
  
)

export default component.exports